import { DetailView } from '@pro4-erp/core-web';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import ValidCertificatesPage from '../components/ValidCertificates';
import UnValidCertificatesPage from '../components/UnValidCertificates';

const BrowsePage = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 1 }}>
      <DetailView
        childrenSx={{ padding: '2rem' }}
        title={
          <DetailView.Title>{`${t('Certificates', {
            defaultValue: 'Certificates',
          })}`}</DetailView.Title>
        }
        tabs={[
          { id: 'valid', title: t('Valid certificates', { defaultValue: 'Valid certificates' }) },
          {
            id: 'unvalid',
            title: t('Unvalid certificates', { defaultValue: 'Unvalid certificates' }),
          },
        ]}
        defaultTab="valid"
      >
        {({ TabContent }) => (
          <>
            <TabContent tab="valid">
              <ValidCertificatesPage />
            </TabContent>
            <TabContent tab="unvalid">
              <UnValidCertificatesPage />
            </TabContent>
          </>
        )}
      </DetailView>
    </Box>
  );
};

export default BrowsePage;
